module.exports = __webpack_public_path__ + "img/EmailB.4ea553ca.svg";